import { render, staticRenderFns } from "./HkiaraceRedeemWelcomeGift.vue?vue&type=template&id=a8808c8e"
import script from "./HkiaraceRedeemWelcomeGift.vue?vue&type=script&lang=js"
export * from "./HkiaraceRedeemWelcomeGift.vue?vue&type=script&lang=js"
import style0 from "./HkiaraceRedeemWelcomeGift.vue?vue&type=style&index=0&id=a8808c8e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports